import { useNavigate, useParams } from "react-router-dom";
import { useMutation, useQuery } from "shared/hooks/useApi";
import graphql from "utils/api/graphql";
import { SCREENS } from "utils/constants";
import View from "./View";

const Detail = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const cancel = () => navigate(SCREENS.PRIVATE.ADMIN.QUALIFIERS.LIST.path);
  const [updateQualifier] = useMutation(graphql.mutations.UPDATE_QUALIFIER, {
    onCompleted: () => {
      navigate(SCREENS.PRIVATE.ADMIN.QUALIFIERS.LIST.path);
    },
    onError: () => {},
  });
  const { data, loading, error } = useQuery(graphql.queries.QUALIFIER, {
    variables: { where: { id } },
  });
  const onSubmit = (_) => {
    const { requirements, ...rest } = _;
    return updateQualifier({
      variables: {
        where: {
          id,
        },
        data: {
          fields: { requirements },
          ...rest,
        },
      },
    });
  };

  if (loading || error) return "Loading";

  return <View onSubmit={onSubmit} data={data.qualifier} cancel={cancel} />;
};

export default Detail;
